import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMenuOutboundLayoutContext } from 'widgets/Menu/ui/MenuOutbound'
import { TriggersPageStore } from 'pages/triggers/store/triggersPageStore'
import { TriggersPageContext } from 'pages/triggers/context'

export const TriggersLayout = observer(() => {
  const entities = useEntitiesContext()
  const menuLayoutStore = useMenuOutboundLayoutContext()
  const [triggerPageStore] = useState(
    () => new TriggersPageStore(menuLayoutStore.pageLayoutStore, entities)
  )

  return (
    <TriggersPageContext.Provider value={triggerPageStore}>
      <Outlet />
    </TriggersPageContext.Provider>
  )
})
